<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/lklapppointsnewodetoJoyinfo/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
            downloadPower="/lklapppointsnewodetoJoyinfo/PeopleExport"
            :showDownloadPower="false"
            @down="down"
            showDownloadPowerType="warning"
        >
            <el-form-item label="SN">
                <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="代理商ID">
                <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商户号">
                <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="sn"
                label="SN"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="agentId"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="activityName"
                label="活动名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="number"
                label="期数"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="qualifiedTransactions"
                label="达标交易量(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="reward"
                label="每期奖励金(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="finalReward"
                label="最终奖励(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                :formatter="formatterTablestatus"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="创建时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                v-if="hasPerm('/lklapppointsnewodetoJoyinfo/look')"
                label="操作"
                min-width="260"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="hasPerm('/lklapppointsnewodetoJoyinfo/look')"
                        @click="openAddDialog(scope.row)"
                    >修改
                    </el-button>
                    <el-button
                        type="text"
                        v-if="hasPerm('/lklapppointsnewodetoJoyinfo/look')"
                        @click="look(scope.row)"
                    >明细
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '修改'"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="439px"
        >
            <el-form-item label="SN" prop="sn">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="dialogModel.sn"
                    placeholder="请输入"
                    style="width: 280px"
                ></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TimeRange from "service/constant/TimeRange";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";
    import StatisticsService from "service/StatisticsService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "twoapppointsnewodetoJoyinfo",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                formModel: {
                    sn: "",
                    agentId: "",
                    status: "",
                    merNo: "",

                    time: TimeRange.monthRange,
                    payTime: "",
                },
                tableData: [],
                status: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "0",
                        dictValue: "未启动",
                    },
                    {
                        dictKey: "1",
                        dictValue: "进行中",
                    },
                    {
                        dictKey: "2",
                        dictValue: "已结束",
                    },
                    {
                        dictKey: "3",
                        dictValue: "已完成",
                    },
                ],
                itemId: "",
                dialogModel: {
                    sn: "",
                },
                dialogRules: {
                    sn: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                },
                submitService: TransactionService.lklapppointsnewodetoJoyinfoList,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                if (this.formModel.payTime == null || this.formModel.payTime == "") {
                    this.formModel.payTime = [];
                }
                const params = {
                    sn: this.formModel.sn,
                    agentId: this.formModel.agentId,
                    status: this.formModel.status,
                    merNo: this.formModel.merNo,

                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                if (this.formModel.payTime.length) {
                    params.startPayTime = this.formModel.payTime[0];
                    params.endPayTime = this.formModel.payTime[1];
                }
                return params;
            },
            dialogData() {
                const params = {
                    sn: this.dialogModel.sn,
                };
                if (this.itemId) {
                    params.id = this.itemId;
                }
                console.log(params);
                return params;
            },
            dialogService() {
                return TransactionService.lklapppointsnewodetoJoyinfoEdit;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    status: "",
                    time: TimeRange.monthRange,
                    payTime: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            openAddDialog(item, flag) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.isFlag = true;
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                }
                this.$refs.formDialog.open();
            },

            dialogClose() {
                this.dialogModel = {
                    sn: "",
                };
                this.itemId = "";
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            look(row) {
                this.$router.push({
                    name: "lklapppointsnewodetojoyinfolook",
                    params: {
                        item: JSON.stringify(row),
                    },
                });
            },
            formatterTablestatus(row, column, cellValue, index) {
                let value = "--";
                this.status.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            down() {
                this.limitExport(this.page.total)
                    ? StatisticsService.exportExcel(
                    this.submitData,
                    "exportHlfInfo",
                    "8885",
                    "/hlf/t-hlf-info-dtl/"
                    )
                    : "";
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/LKLAppPointsNewOdeToJoyInfo.vue